// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610050506/js/" + chunkId + "." + {"44":"cdc23349","225":"d1cb968f","481":"9e1ccccb","486":"d57cb893","770":"14854eba"}[chunkId] + ".0.03857150042894775.chunk.js";
};